import { AfterViewInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, ElementRef, Input, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { UploaderService } from './uploader.service';

@Component({
    selector: 'uploader-detail',
    templateUrl: 'uploader.detail.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UploaderDetailComponent implements AfterViewInit {
    @Input() public files: any[];
    @ViewChildren('imagePreview') public imagesPreview: QueryList<ElementRef>;

    constructor(public uploaderService: UploaderService) { }

    renderThumbnail() {
        if (!this.files || !this.imagesPreview) return;
        this.files.forEach(p => {
            const element = this.imagesPreview.find(x => x.nativeElement.id === p.id);
            if (element) {
                this.uploaderService.Uploader.drawThumbnail(p.id, element.nativeElement, 100, false);
            }
        });
    }

    ngAfterViewInit(): void {
        this.renderThumbnail();
    }
}
